module.exports = __webpack_public_path__ + "img/pic2.3fde0b18.png";